import script from "./ApertureImageViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ApertureImageViewer.vue?vue&type=script&setup=true&lang=js"

import "./ApertureImageViewer.vue?vue&type=style&index=0&id=7b6a1535&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6a1535"]])

export default __exports__